import { createCustomSelector } from '../../domain/utils/react-reselect'
import { selectIsOnboardingContext } from '../navigation/navigation.selectors'
import { selectMapZoom } from '../map/map.selectors'

const MINIMAL_ZOOM_FOR_POI = 14

export const selectOptionsForGeoentityRequestMove = createCustomSelector(
  selectIsOnboardingContext,
  selectMapZoom,
  (onboardingContext, mapZoom) => {
    if (onboardingContext) return { avoidAnimation: true, zoom: MINIMAL_ZOOM_FOR_POI }
    if (mapZoom < MINIMAL_ZOOM_FOR_POI) return { zoom: MINIMAL_ZOOM_FOR_POI }
    return {}
  }
)
